// extracted by mini-css-extract-plugin
module.exports = {"zamora_odonto_center__redText":"ZamoraOdontoCenter_zamora_odonto_center__redText__33hpi","zamora_odonto_center__image":"ZamoraOdontoCenter_zamora_odonto_center__image__2nwIO"};